export default class SubmissionError extends Error {
  constructor (errors) {
    super('Submit Validation Failed')
    this.errors = errors
    this.constructor = SubmissionError
    this.__proto__   = SubmissionError.prototype
  }
}
